const $ = jQuery.noConflict();

'use strict';
const Tabs = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {

		const loaderSlider = $('.js-slider-loader');
		loaderSlider.addClass('isactive');
		setTimeout(() => {
			loaderSlider.removeClass('isactive');
		}, 500);

		$('.slider-gallery__tabs-link').on('click', function(evt) {
			evt.preventDefault();
			$(this).addClass('is-active');
			$(this).siblings('.slider-gallery__tabs-link.is-active').removeClass('is-active');
			const sel = this.getAttribute('data-toggle-target');
			$('.slider-gallery__wrap-boxes').removeClass('is-active').filter(sel).addClass('is-active');
			$('.js-slider-loader').addClass('isactive');
			setTimeout(() => {
				$('.js-slider-loader').removeClass('isactive');
			}, 800);
		});

		$('.gallery-boxes__tabs-link').on('click', function(evt) {
			evt.preventDefault();
			$(this).addClass('is-active');
			$(this).siblings('.gallery-boxes__tabs-link.is-active').removeClass('is-active');
			const sel = this.getAttribute('data-toggle-target');
			$('.gallery-boxes__wrapper').removeClass('is-active').filter(sel).addClass('is-active');
		});
	},
};

export default Tabs;